module.exports = __webpack_public_path__ + "static/media/PortsyARCall_elImage_330739.0e9787f1.jpg";